import { render, staticRenderFns } from "./DashboardListe.vue?vue&type=template&id=28f81470&scoped=true"
import script from "./DashboardListe.vue?vue&type=script&lang=js"
export * from "./DashboardListe.vue?vue&type=script&lang=js"
import style0 from "./DashboardListe.vue?vue&type=style&index=0&id=28f81470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f81470",
  null
  
)

export default component.exports